import { getQueryObject } from "./utils/extend";

const storageParams = () => {
  try {
    const params: any = getQueryObject(window.location.href) || {};
    params.token && localStorage.setItem("token", params.token);
    localStorage.setItem("position", params.gravity || "bottom");
    localStorage.setItem("standard", params.standard || "0");
  } catch (err) {
    console.log(err);
  }
};

const initDsbridge = () => {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isIOS) {
    // window.awsdk = {}
    // console.log('x', Object.keys(SdkTypes))
  }
};

const initPermissionCallback = () => {
  window.awsdkGranted = [];
  window.onPermissionGranted = (alias: string) => {
    if (window.awsdkGranted.indexOf(alias) === -1) {
      window.awsdkGranted.push(alias);
    }
  };
};

const init = () => {
  storageParams();
  initDsbridge();
  initPermissionCallback();
};

init();
